import { ActionReducerMap } from "@ngrx/store";
import { authenticationReducer } from "./Authentication/authentication.reducer";
import { LayoutState, layoutReducer } from "./layouts/layouts.reducer";
import { AuthenticationState } from "./Authentication/auth.models";
import { paymentRecordReducer, PaymentRecordsState } from "./Payment/payment.reducer";
import { dossierRecordReducer, DossierRecordsState } from "./Dossier/dossier.reducer";

export interface RootReducerState {
    layout: LayoutState;
    auth: AuthenticationState;
    paymentRecords: PaymentRecordsState;
    dossierRecords: DossierRecordsState;
}

export const rootReducer: ActionReducerMap<RootReducerState> = {
    layout: layoutReducer,
    auth: authenticationReducer,
    paymentRecords: paymentRecordReducer,
    dossierRecords: dossierRecordReducer
}